import {query} from "@/graphql/client";
import {Booking, ShiftType} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelDateTimeString} from "@/graphql/kapitelTypes";
import datetime from "@/helper/datetime/datetime";
import date from "@/helper/datetime/date";
import {pluralize, pluralizeUnitOnly} from "@/helper/amountFormatter";
import {getArrayUnique} from "@/helper/array";
import {graphql} from "@/graphql/generated";

export const bookingFragment = graphql(`fragment BookingFragment on Booking {
    id
    date
    begin
    until
    shiftType
}`)

export const bookingDetailFragment = graphql(`
    
    
    
    
    
    fragment BookingDetailFragment on Booking {
    id
    date
    begin
    until
    workingHours
    jobsite {
        ...JobsiteFragment
        client {
            ...ClientFragment
            address {
                ...AddressFragment
            }
        }
        house {
            ...HouseFragment
            address {
                ...AddressFragment
            }
        }
        contact {
            ...ContactFragment
        }
    }
    qualification {
        label
    }
    shiftInformation{
        comment,
        requestedBy {
            ...ContactFragment
        }
    }
    bookedBy {
        ...ContactFragment
    }
    shiftType
}`)

export const isShift = (
    booking: Booking,
    typeNeedle: ShiftType
): boolean => booking.shiftType === typeNeedle

export async function fetchBookings(): Promise<any>
{
    const result = await query(
        graphql(`
            query GetAllBookings {
            bookings {
                ...BookingDetailFragment
            }
        }`))
    return result?.data?.bookings
}

export async function fetchUpcomingBooking(): Promise<Booking | undefined>
{
    const result = await query(
        graphql(`
            query GetUpcomingBooking {
            upcomingBooking {
                ...BookingDetailFragment
            }
        }`))
    return result?.data?.upcomingBooking
}

export async function fetchBookingsForDateRange(begin: kapitelDateString, until: kapitelDateString): Promise<Array<Booking>>
{
    const result = await query(
        graphql(`
            query GetBookings (
            $min: KapitelDateImmutable!
            $max: KapitelDateImmutable!
        ) {
            bookings(betweenDates: {max: $max, min: $min}) {
                ...BookingDetailFragment
            }
        }`), {
            min: begin,
            max: until
        })

    const bookings = result?.data?.bookings;
    if (!bookings) {
        throw new Error("no bookings in booking response")
    }

    return bookings
}


export const getAllContacts = (booking: Booking) => ({
    bookedBy: booking.bookedBy,
    requestedBy: booking.shiftInformation?.requestedBy,
    jobsite: booking.jobsite?.contact
})

export function getBookingDuration(booking: Booking) : number {
    console.warn("needs to be implemented")
    return 0;
}


export function getBookingSummary(bookings:Booking[]) {
    const shifts = bookings.length
    const hours = bookings.reduce((sum, booking) => sum + booking.workingHours, 0)
    const hoursRounded = Math.round(hours * 10) / 10
    const hoursLabel = hoursRounded.toLocaleString('de-DE')
    const jobsites = getArrayUnique(bookings.map(booking => booking.jobsite.id)).length

    return {
        shifts,
        hours,
        hoursRounded,
        hoursLabel,
        jobsites
    }
}

export function getBookingSummaryString(booking: { date: kapitelDateString, begin: kapitelDateTimeString, until: kapitelDateTimeString, shiftType?: ShiftType } | undefined) : string {
    if (!booking) {
        return ''
    }
    
    return [
        booking.date
            ? date.formatKapitelDate(booking.date, 'd. L. yy')
            : date.formatKapitelDate(datetime.convertDateTime2Date(booking.begin), 'd. L. yy'),
        booking.shiftType,
        `${datetime.convertDateTime2Time(booking.begin)} - ${datetime.convertDateTime2Time(booking.until)}`
    ].join(' ')
}

export function cmpBookingBeginDateTime(b1: Booking, b2: Booking) {
    return datetime.cmpKapitelDateTime(b1.begin, b2.begin)
}


export const pluralizedBookingAmount = (amount: number, lowercase = false, signed = false, zeroAmountOverride : string | undefined = undefined) => {
    const word =`${lowercase ? 'd' : 'D'}ienst`
    return pluralize(amount, word, `${word}e`, zeroAmountOverride, signed)
}

export const pluralizedBookingLabel = (amount: number, lowercase = false) => {
    const word =`${lowercase ? 'd' : 'D'}ienst`
    return pluralizeUnitOnly(amount, word, `${word}e`)
}
